import CustomButton from 'src/core/ui/CustomButton';
import SaveDiscardButtons from 'src/core/tables/helpers/SaveDiscardButton';
import { CustomField } from 'src/core/forms/CustomField';
import { TableViewSelector } from 'src/core/tables/helpers/TableViewDropdown';

export const generateTablePageButtons = (tableSettings, config?) => {
  const submit = config?.submit || null;
  const hideQuickSearch = config?.hideQuickSearch || false;
  const additionalEdits = config?.additionalEdits || null;
  return [
    ...(hideQuickSearch ? [] : [
      { isInGroupedMenu: true, component: <TableViewSelector tableSettings={tableSettings} /> },
      { position: tableQuickSearch.position, component: <CustomField stateProps={{ state: tableSettings.quickFilterValues, setState: tableSettings.setQuickFilterValues }} options={tableQuickSearch.options} sx={tableQuickSearch.sx} /> },
    ]),
    ...(submit ? [{ component: <SaveDiscardButtons tableSettings={tableSettings} submit={submit} additionalEdits={additionalEdits} /> }] : []),
    { isInGroupedMenu: true, component: <CustomButton variant="text" title="Save as Excel" onClick={() => tableSettings?.apiRef.current.exportDataAsExcel()} /> },
    { isInGroupedMenu: true, component: <CustomButton variant="text" title="Save as Csv" onClick={() => tableSettings?.apiRef.current.exportDataAsCsv()} /> },
    { isInGroupedMenu: true, component: <CustomButton variant="text" title="Print" onClick={() => tableSettings?.apiRef.current.exportDataAsPrint()} /> },
    { isInGroupedMenu: true, component: <CustomButton variant="text" title={`${tableSettings?.headerFilter ? 'Hide' : 'Show'} Filters`} onClick={() => tableSettings?.setHeaderFilter(!tableSettings?.headerFilter)} /> },
  ];
};

export const tableQuickSearch = { position: 'start', options: { name: 'QuickFilter', label: 'Quick search', height: '40px', topMargin: '0px', className: 'quick-search' }, sx: { width: 200, maxWidth: '100%', '&.MuiFormControl-root': { marginBottom: 0 } } };
